import React from 'react';
import { useParams } from 'react-router-dom';
import PageTemplate from '../../components/template/PageTemplate';
import BalanceExecutionContainer from '../../containers/balance/BalanceDetailContainer';
import { BALANCE_PAGE_NAME } from '../../constants/service/app/balanceConstants';

const BalanceDetail = () => {
  const { id } = useParams();

  return (
    <PageTemplate pageName={BALANCE_PAGE_NAME.BALANCE_DETAIL}>
      <BalanceExecutionContainer balanceId={Number(id)} />
    </PageTemplate>
  );
};

export default BalanceDetail;
